/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * The criteria that determines which merchants the incentive will be redeemable at. One of:
 * * `ALL_MERCHANTS` - All Ritual merchants
 * * `WORKSPACE` - Workspace merchants only
 * * `RADIUS` - Merchants within the specified radius centered at the workspace
 * * `MERCHANT_LISTS` - Merchants in the specified merchant lists
 * @export
 * @enum {string}
 */
export enum MerchantEligibilityType {
    AllMerchants = 'ALL_MERCHANTS',
    Workspace = 'WORKSPACE',
    Radius = 'RADIUS',
    MerchantLists = 'MERCHANT_LISTS'
}

export function MerchantEligibilityTypeFromJSON(json: any): MerchantEligibilityType {
    return MerchantEligibilityTypeFromJSONTyped(json, false);
}

export function MerchantEligibilityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MerchantEligibilityType {
    return json as MerchantEligibilityType;
}

export function MerchantEligibilityTypeToJSON(value?: MerchantEligibilityType | null): any {
    return value as any;
}

